import {
  UPDATE_PASSWORD_BEGIN,
  UPDATE_PASSWORD_SUCCESS,
  UPDATE_PASSWORD_ERROR,
  CLEAR_PASSWORD_DATA,
} from 'action-creators/user/password/constants';

const initialState = {
  passwordModify: {
    payload: {},
    loading: false,
    error: false,
  },
};

const passwordModifyReducer = (state = initialState.passwordModify, action) => {
  if (action.type === UPDATE_PASSWORD_BEGIN) {
    return {
      ...initialState.passwordModify,
      loading: true,
    };
  }
  if (action.type === UPDATE_PASSWORD_SUCCESS) {
    const { payload } = action;
    return {
      ...initialState.passwordModify,
      payload,
    };
  }
  if (action.type === UPDATE_PASSWORD_ERROR) {
    return {
      ...initialState.passwordModify,
      error: {
        ...action.payload,
      },
    };
  }
  if(action.type === CLEAR_PASSWORD_DATA){
    return initialState
  }
  return state;
};

export default passwordModifyReducer;
